"use strict";

(function( namespace ) {
	var GALoaded = false;

	/**
	* Analytics entry point.
	*/
	namespace.startAnalytics = function( el, player ) {
		var startAnalyticsInternal = function() {
			loadAnalytics( el, player );
		};

		var analyticsFail = function() {
			videojs.log.error( player.id() + " timout waiting for data layer ready" );
		};

		namespace.waitForThenRun( isDataLayerReady, startAnalyticsInternal, analyticsFail );
	};

	/**
	* Check if data mapping and data layer are ready.
	* @returns {bool}
	*/
	var isDataLayerReady = function() {
		return window.HRST && window.dataMapping && window.PARSELY && window.PARSELY.Cookies;
	};

	/**
	* Load Analytics.
	*/
	var loadAnalytics = function( el, player ) {
		if ( !window.HRST || !window.dataMapping ) {
			videojs.log.error( player.id() + " data layer not ready" );
			return;
		}

		var siteData = namespace.site_config.set_site_data(
			window.dataMapping.icrossingId,
			window.dataMapping.fullUrl,
			window.dataMapping.urlHash,
			window.dataMapping.bu
		);

		namespace.loadParsely( siteData );

		namespace.loadYoubora( el, player );

		loadGA(
			window.dataMapping.clientId,
			siteData.ga_id,
			siteData.ga_group_id
		);

		var playerData = getPlayerData( el, player );

		if ( playerData && !player.analyticsRegistered ) {
			player.analyticsRegistered = true;
			new namespace.AnalyticsEvents( player, playerData, siteData );
		}
	};

	var loadGA = function( clientId, gaId, gaGroupId ) {
		if ( GALoaded ) {
			return;
		}

		GALoaded = true;

		var isCookieEnabled = navigator.cookieEnabled;
		var gaOptions = ( !isCookieEnabled ) ? {
			storage: "none",
			clientId: clientId,
		} : "auto";

		if ( gaGroupId !== "" ) {
			window.ga( "create", gaGroupId, gaOptions, "lumiereGaGroupId" );
		}

		if ( gaId !== "" ) {
			window.ga( "create", gaId, gaOptions, "lumiereGaId" );
		}
	};

	var getPlayerData = function( el, player ) {
		var playerData = {};

		if ( window.HRST.site ) {
			playerData.siteName = window.HRST.site.name;
			playerData.domain = window.HRST.site.domain;
		}

		if ( window.HRST.article ) {
			if ( window.HRST.article.section ) {
				playerData.articleSectionName = window.HRST.article.section.name;
				playerData.channelName = window.HRST.article.section.prefix;
			}

			if ( window.HRST.article.subSection ) {
				playerData.articleSubSectionName = window.HRST.article.subSection.name;
				playerData.subChannelName = window.HRST.article.subSection.prefix;
			}

			if ( window.HRST.article.collection ) {
				playerData.articleCollection = window.HRST.article.collection;
				playerData.contentCollectionName = window.HRST.article.collection;
			}

			playerData.title = window.HRST.article.title;
			playerData.articleType = window.HRST.article.type;
			playerData.articleUniversalID = window.HRST.article.universalID;
			playerData.articleSourceSite = window.HRST.article.sourceSite;
			playerData.articleRecommendationModel = window.HRST.article.recommendationModel || "A2";
		}

		if ( player.playlist ) {
			playerData.ad_tag_url = player.adTagUrl;
			
			if ( player.playlist.sources && player.playlist.sources.length > 0 ) {
				playerData.video_type = player.playlist.sources[ 0 ].type;
				playerData.source_title = player.playlist.sources[ 0 ].source;
				playerData.video_title = player.playlist.sources[ 0 ].title;
				playerData.category = player.playlist.sources[ 0 ].category;
				playerData.created_at = player.playlist.sources[ 0 ].createdAt;
				playerData.source_url = player.playlist.sources[ 0 ].sourceUrl;
				playerData.video_id = player.playlist.sources[ 0 ].id;
			}
		}

		playerData.clientId = window.dataMapping.clientId;
		playerData.timestamp = window.dataMapping.timestamp;
		playerData.urlHash = window.dataMapping.urlHash;
		playerData.referral = window.dataMapping.referral;
		playerData.fullUrl = window.dataMapping.fullUrl;
		
		playerData.embed_id = el.getAttribute( "data-player-id" );
		
		playerData.autoplay = player.autoplay();
		playerData.mute = player.muted();
		playerData.disable_ads = false;
		playerData.playerType = "";
		playerData.playerWidth = Math.floor( player.currentWidth() );
		playerData.playerHeight = Math.floor( player.currentHeight() );
		playerData.version = "Video.js " + videojs.VERSION;

		return playerData;
	};
})( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/analytics.js
// module id = 87
// module chunks = 0